// @flow

import PT from 'prop-types'
import * as o from 'rxjs/operators'
import { type Userinfo } from '@vimcar/shared-stores/mobx/Userinfo'
import { type Params, type InitializerViewModel } from '@vimcar/shared-utils/linkViewModel'

type Context = {
  clearStores: () => void,
  models: { userinfo: Userinfo<any> },
}

export type ViewModel = {
  ...InitializerViewModel<any>,
}

const mkViewModel = (
  { initializer }: Params,
  props: {},
  ctx: Context
): ViewModel => initializer(
  () => ctx.models.userinfo.logout().pipe(
    o.tap((res) => {
      if (typeof window === 'undefined') return

      window.addEventListener('unload', () => {
        ctx.clearStores()
      })

      if ('headers' in res && res.headers.location) {
        window.location.assign(res.headers.location)
      }
    })
  ),

  (vm) => vm
)

mkViewModel.contextTypes = {
  clearStores: PT.func.isRequired,
  models: PT.shape({
    userinfo: PT.object.isRequired,
  }).isRequired,
  request: PT.func.isRequired,
}

export default mkViewModel
